import { Button, ButtonProps } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';
import { Plus } from '@ankr.com/ui';

import { AccountPermission } from 'modules/permissions/constants';
import { ChainProjectsSidebar } from 'modules/chains/components/ChainProjectsSidebar';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { GuardResolution } from 'modules/common/components/GuardResolution';
import { useChainsProjects } from 'modules/chains/hooks/useChainsProjects';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { addToProjectButtonTranslation } from './translation';

interface AddToProjectButtonProps {
  chain: Chain;
  size?: ButtonProps['size'];
}

export const AddToProjectButton = ({
  chain,
  size = 'medium',
}: AddToProjectButtonProps) => {
  const { projects, projectsWithChains } = useChainsProjects();

  const {
    isOpened: isOpenedAddToProjectsSidebar,
    onClose: onCloseAddToProjectsSidebar,
    onOpen: handleAddToProjectsDialogOpen,
  } = useDialog();

  const { keys, t } = useTranslation(addToProjectButtonTranslation);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    handleAddToProjectsDialogOpen();
  };

  return (
    <GuardResolution protectedResolution="smDown">
      <GuardAccountPermission permission={AccountPermission.JwtManagerRead}>
        <Button
          size={size}
          variant="outlined"
          onClick={onClick}
          startIcon={<Plus />}
          sx={{
            whiteSpace: 'nowrap',
          }}
        >
          {t(keys.addToProject)}
        </Button>
        <ChainProjectsSidebar
          chain={chain}
          isOpenedAddToProjectsSidebar={isOpenedAddToProjectsSidebar}
          onCloseAddToProjectsSidebar={onCloseAddToProjectsSidebar}
          projects={projects}
          projectsWithBlockchains={projectsWithChains}
        />
      </GuardAccountPermission>
    </GuardResolution>
  );
};
